import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { postConfigPtMonDigital } from "./services";
import { IPostConfigPtMonDigital } from "./types";

const initialState: any = {
  status: "",
  msgError: "",
  data: [],
};

export const actionPostConfigPtMonDigital: any = createAsyncThunk<
  any,
  IPostConfigPtMonDigital
>("ACTION_POST_CONFIG_PT_MON_DIGITAL", async (data, { getState }: any) => {
  const {
    getLojas: { lojaSelected },
    modulosByCentral: {
      entradaSelected: {
        modulo: { idCentral, adrModulo, modelo },
        entrada,
      },
    },
  } = getState();
  return postConfigPtMonDigital({
    ...data,
    idCentral,
    adrModulo,
    modeloModulo: modelo,
    idEntrada: entrada.id,
    idLoja: lojaSelected
  });
});

const slicePostConfigPtMonDigital = createSlice({
  name: "POST_CONFIG",
  initialState,
  reducers: {
    actionResetStateConfigPtMonDigital: (state) => {
      state.status = ""
      state.msgError = ""
    }
  },
  extraReducers: {
    [actionPostConfigPtMonDigital.pending]: (state) => {
      state.status = "loading";
    },
    [actionPostConfigPtMonDigital.fulfilled]: (state) => {
      state.status = "success";
    },
    [actionPostConfigPtMonDigital.rejected]: (state, {error: { message }}) => {
      state.status = "error";
      state.msgError = message
    },
  },
});

export default slicePostConfigPtMonDigital.reducer;
export const { actionResetStateConfigPtMonDigital } =
  slicePostConfigPtMonDigital.actions;
